import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { sync } from '@app/icare/client/sync'
import { PatientFormId, type PatientFormIdType } from '@app/icare/db/schema/form/PatientFormCommon'
import { PatientOrderFormType } from '@app/icare/db/schema/form/PatientFormType'
import { getFormHandler } from '@app/icare/documents/config'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientTherapyId } from '@app/icare/entities/patient/schema/PatientTherapy'
import type { PatientOrderForm } from '@app/icare/entities/patientForm/schema/PatientForm'
import { appFormOptions } from '@app/icare/form/appFormOptions'
import { useAppForm } from '@app/icare/form/useAppForm'
import { t } from '@lingui/core/macro'
import { entityParams } from '@pkg/db/utils'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'
import { NewOrder } from './-new'

const SearchParams = z.object({
  therapyId: PatientTherapyId.ref.nullish(),
  order: z.enum(PatientOrderFormType).nullish(),
})

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/_forms/bedarfsermittlung/new')({
  component: RouteComponent,
  params: entityParams({ id: PatientId }),
  validateSearch: zodValidator(SearchParams),
  loader: async ({ _params, context: { _queryClient } }) => {
    // await queryClient.ensureQueryData(localQueryOneOptions(params.id))
  },
  staticData: {
    layout: {
      menuRender: false,
    },
  },
})

function RouteComponent() {
  const { id } = Route.useParams()
  const formId: PatientFormIdType | undefined = undefined
  const { therapyId, order } = Route.useSearch()
  const router = useRouter()

  if (!therapyId || !order) {
    throw new Error('Therapy ID and Order type must be provided for new order creation.')
  }

  const current = useQuery(localQueryEntityOptions(formId))
  const { validationSchema } = getFormHandler(current.data?.type ?? order)

  const form = useAppForm(
    appFormOptions(validationSchema, {
      defaultValues: (current.data as unknown as PatientOrderForm) ?? {
        patientId: id,
        type: order,
        therapyId,
        status: 'new',
      },
      toast: { subject: t`Bedarfsermittlung` },
      onSubmit: async ({ value }) => {
        await sync.mutate({
          ...value,
          id: PatientFormId.generate(),
        })
        void router.navigate({
          to: '/patienten/$id/bedarfsermittlungen/$therapy',
          replace: true,
          params: { id, therapy: therapyId },
        })
      },
    }),
  )

  // TODO: not forces context. so might need to refactor
  // const { missing } = useOrderArticleCart()

  return (
    <form.AppForm>
      <form.ProForm editablePolicy={{ forceMode: 'edit' }}>
        <NewOrder />
      </form.ProForm>
    </form.AppForm>
  )
}
